export const HIDE_HINT_TIME = 3000;
